<template>

  <div class="odr">
    <!-- 二级导航栏 -->
    <div class="nav">
      <div class="nav-item" v-for="(item, index) in config.navList" :key="index" :class="index == 0 ? 'nav-item0' : ''">
        <div class="nav-title" @click="handleMouseOver(index, item)"
          :class="activeTitle == item.name ? 'active-title' : ''">
          <span class="title">{{ Setsubstring(item.name) }}</span>
          <i class="el-icon-arrow-down" v-if="index == 0 && !showSubTitle"></i>
          <i class="el-icon-arrow-up" v-if="index == 0 && showSubTitle"></i>
          <el-divider v-if="index == 0" direction="vertical"></el-divider>
        </div>
      </div>
      <div v-if="showSubTitle" ref="selectRef"
        :class="config.navList[0].children && config.navList[0].children.length ? 'nav-sub-title' : ''">
        <div class="nav-sub-title-item" v-for="(ele, idx) in config.navList[0].children" :key="idx"
          @click="pageTo(ele)">
          {{ ele.name }}
        </div>
      </div>
    </div>
    <div class="header" v-if="!isMobile">
      <div class="header-left">
        <p class="header-title">{{ config.title }}</p>
        <p class="header-info">{{ config.headerInfo }}</p>
      </div>
      <div class="header-right">
        <img :src="config.headerImg" alt="" />
      </div>
    </div>
    <Nav v-else :headerTitle="config.title" :headerDesc="config.headerInfo" :headerImg="config.headerImg"></Nav>

    <!-- 产品描述、产品功能、应用价值 -->
    <div class="content">
      <div v-for="(item, index) in config.navList" :key="index">
        <p class="title" v-if="activeTitle == item.name">{{ activeTitle }}
        </p>
        <div class="titledesc" v-if="activeTitle == item.name">
          {{ item.desc }}
        </div>

        <div class="tab" v-if="activeTitle == item.name && item.tabList && item.tabList.length">
          <template v-if="item.tabList[0].name">
            <div class="tab-item" v-for="(ele, idx) in item.tabList" :key="idx + 'tab'">
              <p @click="subTitleClick(ele)" :class="activeSubTitle == ele.name ? 'active-sub-title' : ''"
                class="sub-title">
                {{ ele.name }}
              </p>
            </div>
          </template>
        </div>
        <div class="content-data" v-if="activeTitle == item.name">
          <div v-for="(ele, idx) in item[activeSubTitle]
            ? item[activeSubTitle]
            : item.contentData" :key="idx + 'sub'" class="content-data-item">
            <p v-if="ele.title" class="content-title">{{ ele.title }}</p>
            <p v-if="ele.desc" class="content-desc">{{ ele.desc }}</p>
            <div class="content-img">
              <img :src="ele.img" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from './components/nav.vue'
export default {
  name: "",
  props: {
    config: Object,
  },
  data() {
    return {
      showSubTitle: false,
      activeTitle: sessionStorage.getItem("routeQuery"),
      activeSubTitle: this.config.activeSubTitle,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  components: { Nav },
  watch: {},
  mounted() {
    this.activeTitle = sessionStorage.getItem("routeQuery");
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeDestroy() {
    // 组件销毁前，解绑全局点击事件，防止内存泄漏
    document.removeEventListener('click', this.handleDocumentClick);
  },

  methods: {
    // 新增Tab滚动方法
    scrollTab(direction) {
      const tabWrap = document.querySelector('.tab-wrap');
      if (!tabWrap) return;

      // 每次滚动距离（可根据实际需求调整）
      const scrollStep = 120;
      // 目标滚动位置
      const targetLeft = direction === 'left'
        ? tabWrap.scrollLeft - scrollStep
        : tabWrap.scrollLeft + scrollStep;

      // 平滑滚动（核心：使用 scrollTo + behavior: 'smooth'）
      tabWrap.scrollTo({
        left: targetLeft,
        behavior: 'smooth' // 平滑动画
      });
    },
    Setsubstring(str) {
      let ins = str.indexOf('(')
      if (ins != -1) {
        let sub = str.substring(0, ins)
        return sub
      }
      return str
    },

    handleMouseOver(index, item) {
      if (index == 0) {
        this.showSubTitle = !this.showSubTitle;
      } else {
        this.activeTitle = item.name;
        this.showSubTitle = false
      }
      if (item.tabList && item.tabList.length && item.tabList[0].name) {
        this.activeSubTitle = item.tabList[0].name;
      } else {
        this.activeSubTitle = this.config.activeSubTitle
      }
    },
    subTitleClick(item) {
      this.activeSubTitle = item.name;
    },
    pageTo(val) {
      this.showSubTitle = false;
      try {
        this.$router.push(val.url)

      } catch (error) {

      }
    },

    handleDocumentClick(e) {
      // 获取触发下拉的第一个导航项元素（index=0的nav-item）
      const firstNavItem = document.querySelector('.nav-item0');
      // 获取下拉框DOM元素
      const dropdownDom = this.$refs.selectRef;
      // 条件：点击的目标 不是第一个导航项 且 不是下拉框内部 → 隐藏下拉框
      if (firstNavItem && !firstNavItem.contains(e.target) && dropdownDom && !dropdownDom.contains(e.target)) {
        this.showSubTitle = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.subflex {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.kong {
  border: 1.36px dashed #7C7B7D;
  margin: 10px 0;
}

.subflex1 {
  width: 330px;
  font-size: 14px;
  text-align: left;
  margin: 30px 0;
}

.odr {
  position: relative;

  .header {
    position: relative;
    width: 100%;
    height: 500px;
    background: #eaeaf2;
    display: flex;

    .header-left {
      margin: auto;
      padding: 0 62px 0 68px;

      .header-title {
        font-size: 39px;
        color: @mainBgColor;
      }

      .header-info {
        font-size: 16px;
        margin-top: 30px;
        line-height: 32px;
      }
    }

    .header-right {
      min-width: 710px;
      height: 600px;

      img {
        display: inline-block;
        min-width: 710px;
        height: 600px;
      }
    }
  }

  .nav {
    /*   position: absolute; */
    top: 50px;
    background-color: #575765;
    color: white;
    font-size: 14px;
    padding: 22px 0 22px 32px;

    .nav-item0 {
      .el-divider {
        background: white;
        margin-left: 26px;
      }
    }

    .nav-item {
      margin-right: 26px;
      display: inline-block;

      .nav-title {

        .title {
          cursor: pointer;
        }

        .title:hover {
          font-weight: 700;
        }

        i {
          font-size: 12px;
        }
      }

      .active-title {
        font-weight: 700;
        color: #ffee00;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #ffee00;
          border-radius: 1px;
        }
      }
    }

    .nav-sub-title {
      max-width: 210px;
      background: #f6f6fa;
      color: black;
      font-size: 14px;
      padding: 24px;
      position: absolute;
      z-index: 99;
      top: 68px;
      left: 32px;
      transition: opacity 0.25s ease, transform 0.25s ease;
      opacity: 1;
      transform: translateY(0);
      animation: fadeInDown 0.5s ease;

      .nav-sub-title-item {
        margin-bottom: 8px;

        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

  }

  .content {
    // margin: 0px 143px;
    margin: 80px 143px 0 143px;

    .title {
      font-size: 39px;
      margin-bottom: 40px;
    }

    .titledesc {
      letter-spacing: 1px;
      margin: 20px 0;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      color: #000000;
    }

    .tab {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
      border-bottom: 1px solid @mainGrayColor3;

      .tab-item {
        font-size: 19px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        .sub-title {
          padding: 0 50px 17px;
        }

        .active-sub-title {
          border-bottom: 6px solid @mainColor;
          font-weight: 600;
        }
      }
    }

    .content-data {
      .content-data-item {
        margin-bottom: 100px;

        .content-title {
          font-size: 24px;
          margin-bottom: 20px;
          position: relative;

          &::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 24px;
            background: @mainColor;
            position: absolute;
            left: -12px;
            top: 5px;
          }
        }

        .content-desc {
          font-size: 16px;
          margin-bottom: 60px;
        }

        .content-img {
          text-align: center;

          img {
            width: 80%;
          }
        }
      }
    }
  }
}




// 新增：定义滑入动画，搭配v-if必生效
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-8px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media @mobile {
  .odr {
    .header {
      height: auto;
      flex-direction: column;
      // padding: 30px 20px;
      box-sizing: border-box;

      .header-left {
        padding: 0;
        background-color: #2E2E38;
        color: #FFFFFF;
        padding: 140px 15px;

        .header-title {
          font-size: 24px;
          text-align: left;
          color: #FFF100;
        }

        .header-info {
          font-size: 14px;
          line-height: 24px;
          margin-top: 15px;
          text-align: left;
        }
      }

      .header-right {
        min-width: auto;
        width: 100%;
        height: auto;

        img {
          min-width: auto;
          width: 100%;
          height: auto;
          display: block;
        }
      }
    }

    .content {
      margin: 40px 20px 0;

      .tab {
        // 重置所有PC端样式，避免干扰
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
        margin-bottom: 30px !important;
        border-bottom: 1px solid @mainGrayColor3 !important;
        padding: 0 !important;
        width: 100% !important;
        overflow-x: auto;

        // ========== 显示滚动条 ==========
        &::-webkit-scrollbar {
          display: block !important; // 强制显示滚动条
          height: 2px !important; // 滚动条高度（可自定义）
        }

        // 滚动条轨道样式
        &::-webkit-scrollbar-track {
          background: #f5f5f5 !important; // 轨道背景色
          border-radius: 2px !important; // 轨道圆角
        }

        // 滚动条滑块样式
        &::-webkit-scrollbar-thumb {
          background: black !important; // 滑块颜色（复用主题色）
          border-radius: 2px !important; // 滑块圆角
        }


        // Tab项样式
        .tab-item {
          flex: none !important; // 禁止收缩
          font-size: 16px !important;

          .sub-title {
            padding: 0 20px 12px !important;
            display: inline-block !important;
          }

          .active-sub-title {
            border-bottom: 4px solid @mainColor !important;
            font-weight: 600 !important;
          }
        }
      }


      .title {
        font-size: 24px;
        margin-bottom: 20px;
        text-align: center;
      }

      .titledesc {
        font-size: 14px;
        // line-height: 24px;
        margin: 15px 0;
        text-align: left;
      }



      .content-data {
        .content-data-item {
          margin-bottom: 60px;

          .content-title {
            font-size: 18px;
            margin-bottom: 15px;
            padding-left: 15px;

            &::before {
              width: 4px;
              height: 18px;
              left: 0;
              top: 3px;
            }
          }

          .content-desc {
            font-size: 14px;
            margin-bottom: 30px;
          }

          .content-img {
            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
